<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Edit Event</p>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <router-link
              :to="{ name: 'photogallaryList' }"
              class="button is-info is-small btnicon"
              title="Back To List"
            >
              Back To List
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="container section is-main-section">
      <form @submit.prevent="save">
        <div>
          <div class="columns row">
            <div class="column is-4">
              <label class="label"
                >From <span class="requir has-text-danger">*</span></label
              >
              <div class="control">
                <input class="input" type="date" v-model="fromDate" required />
              </div>
            </div>

            <div class="column is-4">
              <label class="label"
                >To <span class="requir has-text-danger">*</span></label
              >
              <div class="control">
                <input
                  class="input"
                  :min="this.fromDate"
                  type="date"
                  v-model="toDate"
                  required
                />
              </div>
            </div>
            <div class="column is-4">
              <div class="field">
                <label class="label">
                  Title <span class="requir has-text-danger">*</span></label
                >
                <div class="control">
                  <input class="input" v-model="title" required type="text" />
                </div>
              </div>
            </div>
          </div>
          <div class="columns row" style="width: 100%">
            <div class="columns form-row" style="width: 100%">
              <div class="column is-12">
                <div class="field">
                  <label class="label">
                    Description
                    <span class="requir has-text-danger">*</span></label
                  >
                  <!-- <ckeditor required v-model="discription" ref="ckeditorRef"></ckeditor> -->
                  <!-- <textarea class="input" rows="3" required clearable v-model="discription" ref="ckeditorRef"></textarea> -->
                  <quill-editor
                    v-model="discription"
                    theme="snow"
                    ref="myQuillEditor"
                  >
                  </quill-editor>
                </div>
              </div>
            </div>
          </div>
          <div class="columns form-row">
            <div class="column is-3">
              <div class="field">
                <!-- <label class="label"
                  >Image / Video (please select image or video for
                  upload)</label
                > -->
                 <label class="label"
                    >Image (please select image for
                    upload)<span class="requir has-text-danger">*</span></label
                  >
                <div class="control p-t-7">
                  <b-radio
                    @input="changed()"
                    name="imagevideo"
                    v-model="imagevideo"
                    native-value="image"
                  >
                    Image
                  </b-radio>
                  <span v-if="showimageerror" class="has-text-danger" style="display:block;margin-top:4px;">
                    Please select Image option
                  </span>
                  <!-- <b-radio
                    name="imagevideo"
                    v-model="imagevideo"
                    native-value="video"
                  >
                    Video
                  </b-radio> -->
                </div>
              </div>
            </div>
            <div v-if="this.imagevideo === 'image'" class="column is-6">
              <!-- <div class="field">
                <label class="label">upload / Insert Url </label>
                <div class="control p-t-7">
                  <b-radio
                    required
                    name="uploadcopy"
                    v-model="uploadcopy"
                    native-value="upload"
                  >
                    upload
                  </b-radio>
                  <b-radio
                    name="uploadcopy"
                    v-model="uploadcopy"
                    native-value="copy"
                  >
                    Insert Url
                  </b-radio>
                </div>
              </div> -->
              <!-- <div v-if="this.uploadcopy === 'copy'" class="column is-5">
                <div class="field">
                  <label class="label"> Image Url </label>
                  <div class="control">
                    <input
                      :disabled="this.dropFile1.length > 9"
                      class="input"
                      v-model="imgUrl"
                      required
                      type="text"
                    />
                  </div>
                </div>
              </div> -->
              <div v-if="this.uploadcopy === 'upload'" class="column is-5">
                <div class="field">
                  <label class="label">
                    select file
                    <span class="requir has-text-danger">*</span>
                  </label>
                  <b-field
                    :class="`file ${
                      this.dropFile1.length > 9 ? ' ' : 'is-primary'
                    }`"
                  >
                    <b-upload
                      :disabled="this.dropFile1.length > 9"
                      @input="onFilechange()"
                      v-model="dropFile"
                      multiple
                      class="file-label"
                    >
                      <span class="file-cta">
                        <b-icon class="file-icon" icon="upload"></b-icon>
                        <span class="file-label">Click to upload</span>
                      </span>
                    </b-upload>
                  </b-field>
                  <span class="has-text-danger">please select only image</span>

                  <span v-if="dropFile.length > 0">
                    <div class="tags" v-for="(file, i) in dropFile" :key="i">
                      <span class="tag is-primary">
                        {{ file.type }}
                      </span>
                      <button
                        class="delete is-small"
                        type="button"
                        @click="deleteDropFile(i)"
                      ></button>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div v-if="this.imagevideo === 'video'" class="column is-3">
              <div class="field">
                <label class="label"> Video Url </label>
                <div class="control">
                  <input
                    :disabled="this.dropFile1.length > 9"
                    class="input"
                    v-model="vdoUrl"
                    required
                    type="text"
                  />
                </div>
              </div>
            </div>
            <button
              class="button is-success"
              :disabled="hasClicked"
              type="submit"
              style="margin-top: 38px"
            >
              Save
            </button>
          </div>
        </div>
        <div></div>
      </form>
      <span v-if="dropFile1.length > 0"
        ><b>uploded images</b>
        <div class="tags" v-for="(file, i) in dropFile1" :key="i">
          <!-- <div
            v-if="file.type === 'VIDEO'"
            @click="downloadVid(file.urlPath)"
            class="tag is-primary"
          >
            {{ file.name }}
          </div> -->
          <div
            v-if="file.type === 'IMAGE' && file.isLink === false"
            @click="downloadImg(file.urlPath)"
            class="tag is-primary"
          >
            {{ file.name }}
          </div>
          <div
            v-if="file.type === 'IMAGE' && file.isLink === true"
            @click="viewImg(file.urlPath)"
            class="tag is-primary"
          >
            {{ file.name }}
          </div>
          <button
            class="delete is-small"
            type="button"
            @click="deleteDropFile1(file.id)"
          ></button>
        </div>
      </span>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'

import Utils from '@/utils'
import moment from 'moment'
// import Vue from 'vue'
// import CKEditor from 'ckeditor4-vue'
// Vue.use(CKEditor)
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'editPhotogallary',
  props: ['photoGalleryID'],
  components: {
    quillEditor
  },
  data () {
    return {
      total: 0,
      dropFile: [],
      discription: '',
      type: '',
      fromDate: '',
      toDate: '',
      vdoUrl: '',
      upload: '',
      imgUrl: '',
      uploadcopy: '',
      imagevideo: '',
      title: '',
      typeData: [],
      annonceData: [],
      hasClicked: false,
      loader: true,
      sendData: {},
      selectedfranchiseeID: [],
      dropFile1: [],
      documentData: [],
      isWrite: false,
      deleteFileIdArr: [],
      showimageerror: false
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.photoGallery()
    await this.photoGalleryDocument()
  },
  beforeRouteLeave (to, from, next) {
    // Ckeditor maximize fix and Alert on unsaved changes
    // const that = this.$refs.ckeditorRef
    // const maximizedState = that.instance.getCommand('maximize').state
    // if (maximizedState === 1) { that.instance.execCommand('maximize') }
    // if (this.hasDataChanged() && !this.hasClicked) {
    //   return this.$buefy.dialog.confirm({
    //     title: 'Leave Page',
    //     message: 'Do you really want to leave? you have unsaved changes!',
    //     type: 'is-danger',
    //     cancelText: 'No',
    //     confirmText: 'Yes',
    //     onConfirm: () => { next() },
    //     onCancel: () => { next(false) }
    //   })
    // } else
    next()
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.preventNav)
  },
  methods: {
    preventNav (event) {
      if (!this.hasDataChanged()) return
      event.preventDefault()
      event.returnValue = ''
    },
    hasDataChanged () {
      const prevTitle = this.annonceData.title
      const prevDescription = this.annonceData.descriptions
      const prevFromDate = moment(
        this.annonceData.startDate,
        'YYYY-MM-DD'
      ).format('YYYY-MM-DD')
      const prevToDate = moment(this.annonceData.endDate, 'YYYY-MM-DD').format(
        'YYYY-MM-DD'
      )
      const boolAlert =
        this.discription !== prevDescription ||
        this.dropFile.length > 0 ||
        this.title !== prevTitle ||
        this.fromDate !== prevFromDate ||
        this.toDate !== prevToDate
      return boolAlert
    },
    photoGallery: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/photo-gallery/${this.photoGalleryID}`
        )
        this.annonceData = data
        this.title = this.annonceData.title
        this.discription = this.annonceData.descriptions
        this.fromDate = moment(this.annonceData.startDate, 'YYYY-MM-DD').format(
          'YYYY-MM-DD'
        )
        this.toDate = moment(this.annonceData.endDate, 'YYYY-MM-DD').format(
          'YYYY-MM-DD'
        )
        // this.dropFile1 = this.annonceData.photoGalleryDocumentMaps
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    photoGalleryDocument: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/photo-gallery/${this.photoGalleryID}`
        )
        this.documentData = data
        this.dropFile1 = this.documentData.photoGalleryDocumentMaps
        if (this.dropFile1) {
          this.dropFile1.forEach((docID) => {
            docID.name = docID.urlKey.substring(
              docID.urlKey.lastIndexOf('/') + 1
            )
          })
        }
        this.annonceData.photoGalleryDocumentMaps = this.dropFile1
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    deleteDropFile1 (docID) {
      this.$buefy.dialog.confirm({
        title: 'Deleting Image',
        message: '"Do you want to Delete this file"?',
        confirmText: 'Delete Image',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.dropFile1.forEach((element) => {
            if (docID === element.id) {
              var index = this.dropFile1.indexOf(element)
              if (index !== -1) {
                this.dropFile1.splice(index, 1)
              }
              this.deleteFileIdArr.push(docID)
            }
          })
          if (this.dropFile1.length === 0) {
            this.annonceData.photoGalleryDocumentMaps = 0
          }
        }
      })
    },

    save: async function () {
      let discriptionTest = this.discription
      discriptionTest = discriptionTest.replace(/(<([^>]+)>)/gi, '')
      discriptionTest = discriptionTest.replace(/&nbsp;/g, '')
      discriptionTest = discriptionTest.trim()
      if (
        discriptionTest === '' ||
        !discriptionTest ||
        discriptionTest === null
      ) {
        return this.$buefy.toast.open({
          message: 'Please fill Description',
          type: 'is-danger',
          duration: 4000
        })
      }
      let docCount = 0
      if (Array.isArray(this.annonceData.photoGalleryDocumentMaps)) {
        docCount = this.annonceData.photoGalleryDocumentMaps.length
      } else if (typeof this.annonceData.photoGalleryDocumentMaps === 'number') {
        docCount = this.annonceData.photoGalleryDocumentMaps
      }
      if (docCount < 1) {
        if (this.imagevideo === 'image') {
          // if (this.uploadcopy === 'copy' && this.imgUrl === '') {
          //   return this.$buefy.toast.open({
          //     message: 'Please Insert Atleast 1 Image Url',
          //     type: 'is-danger',
          //     duration: 4000
          //   })
          // }
          if (this.uploadcopy === 'upload' && this.dropFile.length < 1) {
            return this.$buefy.toast.open({
              message: 'Please select Atleast 1 image',
              type: 'is-danger',
              duration: 4000
            })
          }
        }
        if (this.imagevideo === 'video' && this.vdoUrl === '') {
          return this.$buefy.toast.open({
            message: 'Please Insert Atleast 1 Video Url',
            type: 'is-danger',
            duration: 4000
          })
        }
        if (
          this.imagevideo === 'image' &&
          this.uploadcopy === 'upload' &&
          this.dropFile.length === 0
        ) {
          return this.$buefy.dialog.alert({
            message: 'photogallery needs atlest one Document',
            type: 'is-danger',
            duration: 4000
          })
        }
        if (this.dropFile.length === 0) {
          this.showimageerror = true
          return this.$buefy.toast.open({
            message: 'Please select Atleast 1 image ',
            type: 'is-danger',
            duration: 4000
          })
        }
      }
      if (this.imagevideo === 'image' && this.uploadcopy !== 'upload') {
        if (!this.validURL(this.imgUrl)) {
          return this.$buefy.toast.open({
            message: 'Please Enter Valid Image URL',
            type: 'is-danger',
            duration: 4000
          })
        }
      } else if (this.imagevideo === 'video' && this.uploadcopy !== 'upload') {
        return this.$buefy.toast.open({
          message: 'Please Enter Valid Video URL',
          type: 'is-danger',
          duration: 4000
        })
      }
      if (this.deleteFileIdArr.length > 0) {
        this.deleteFileIdArr.forEach((docID) => {
          this.deleteDocument(docID)
        })
      }
      let formData = new FormData()
      formData.append('descriptions', this.discription)
      formData.append('title', this.title)
      formData.append('startDate', this.fromDate)
      formData.append('endDate', this.toDate)
      if (this.imagevideo === 'image' && this.uploadcopy !== 'upload') {
        formData.append('type', 'IMAGE')
        formData.append('link', this.imgUrl)
        formData.append('isLink', 'true')
      } else if (this.imagevideo === 'video') {
        formData.append('type', 'VIDEO')
        formData.append('link', this.vdoUrl)
        formData.append('isLink', 'true')
      }
      if (this.imagevideo === 'image' && this.uploadcopy === 'upload') {
        for (let i = 0; i < this.dropFile.length; i++) {
          formData.append('file', this.dropFile[i])
        }
      }
      // for (var pair of formData.entries()) {
      //   console.log(pair)
      // }
      this.hasClicked = true
      try {
        await http.put(
          `${constants.API_URL}/api/communication/photo-gallery/${this.photoGalleryID}`,
          formData
        )
        this.loader = false
        this.$router.push({ name: 'photogallaryList' })
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    downloadVid: async function (i) {
      window.open(i)
    },
    viewImg: async function (i) {
      window.open(i)
    },
    downloadImg: async function (i) {
      try {
        let url = await http.get(
          `${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`
        )
        window.open(url.data)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    deleteDocument: async function (deldocID) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        await http.get(
          `${constants.API_URL}/api/communication/photo-gallery/document/status/${deldocID}`
        )
        this.loadingComponent.close()
        // this.photoGalleryDocument()
        this.dropFile = []
        this.annonceData.photoGalleryDocumentMaps = 0
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    onFilechange () {
      let size = this.dropFile.some((a) => {
        return a.size > 5000000
      })
      if (size) {
        this.dropFile.pop()
        return this.$dialog.error({
          text: `file size is too big`,
          title: 'File Upload Error'
        })
      }
      let r = this.dropFile.some((a) => {
        return (
          a.type !== 'image/jpeg' &&
          a.type !== 'image/jpg' &&
          a.type !== 'image/png'
        )
      })
      if (r === true) {
        this.dropFile.pop()
        return this.$buefy.dialog.alert({
          message: 'please select jpeg , jpg , png format only',
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    changed () {
      this.dropFile = []
      this.uploadcopy = 'upload'
      // this.imgUrl = ''
      // this.vdoUrl = ''
      this.showimageerror = false
    },
    validURL (str) {
      var pattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$',
        'i'
      ) // fragment locator
      return !!pattern.test(str)
    }
  }
}
</script>
<style scoped>
textarea {
  background-color: #ffffff;
  border-color: #dbdbdb;
  border-radius: 4px;
  color: #363636;
  height: 9.5rem;
}
</style>
